import { AlternatingLayout, UserGeneratedHtml } from '@atlassian/mpac-ui';
import * as React from 'react';
import { TEST_ID } from "../../../../../constants";
import Image from "../../../../Image";
import { H2, H3, HeroAndHighlightsContainer, HighlightContainer } from "./HeroAndHighlights.styles";
import YouTubeIframe from "./YouTubeIframe";
const HeroAndHighlights = props => {
  // fix later MC-2850
  const {
    highlights,
    onHighlightClick,
    heroImage,
    youtubeId,
    tagline
  } = props;
  const getHeroMedia = () => {
    if (youtubeId) return /*#__PURE__*/React.createElement(YouTubeIframe, {
      youtubeId: youtubeId
    });else if (heroImage) return /*#__PURE__*/React.createElement(Image, {
      image: heroImage,
      "data-testid": TEST_ID.OVERVIEW_TAB_HERO_IMAGE
    });
    // Apps should always have a hero image or youtube video
    // if this function was called, the last case should be unreachable
    else return /*#__PURE__*/React.createElement("div", null);
  };
  return /*#__PURE__*/React.createElement(HeroAndHighlightsContainer, {
    "data-testid": TEST_ID.OVERVIEW_TAB_HERO_HIGHLIGHTS
  }, /*#__PURE__*/React.createElement(AlternatingLayout, null, heroImage || youtubeId ? /*#__PURE__*/React.createElement(AlternatingLayout.Row, null, /*#__PURE__*/React.createElement(H2, null, tagline), getHeroMedia()) : /*#__PURE__*/React.createElement(AlternatingLayout.Row, null, /*#__PURE__*/React.createElement(H2, null, tagline)), highlights.map((highlight, index) =>
  /*#__PURE__*/
  // using image url as key here since title can be null
  React.createElement(AlternatingLayout.Row, {
    key: highlight.image.url
  }, /*#__PURE__*/React.createElement(HighlightContainer, null, /*#__PURE__*/React.createElement(H3, null, highlight.title), highlight.summary && /*#__PURE__*/React.createElement(UserGeneratedHtml, {
    "data-testid": TEST_ID.OVERVIEW_TAB_HIGHLIGHT_SUMMARY,
    dangerousHtml: highlight.summary
  })), /*#__PURE__*/React.createElement(Image, {
    image: highlight.croppedImage,
    "data-testid": TEST_ID.OVERVIEW_TAB_HIGHLIGHT_IMAGE,
    onClick: () => onHighlightClick(highlight),
    loading: index === 0 ? 'eager' : 'lazy'
  })))));
};
export default HeroAndHighlights;